// extracted by mini-css-extract-plugin
export default {"charts":"Charts_charts__LDlqh","chart":"Charts_chart__fUZj9"};